import UiTooltip from '@/shared/ui/ui-tooltip'
import { Link } from 'react-router-dom'

const LinkCusstom = ({ noUnderline, ...rest }: any) => {
  const customStyle = noUnderline ? { textDecoration: 'none', ...rest.style } : rest.style
  return (
    <UiTooltip title={rest.children} placement="right" mouseEnterDelay={0.8}>
      <Link to={rest.to} {...rest} style={customStyle}>
        {rest.children}
      </Link>
    </UiTooltip>
  )
}

export default LinkCusstom
